import { CardHighlight01Styles } from './CardHighlight01.styled';

export const CardHighlight01: React.FC<
  React.ComponentPropsWithoutRef<'div'>
> = ({ children, ...rest }) => {
  return (
    <CardHighlight01Styles.Root {...rest}>
      {children}
    </CardHighlight01Styles.Root>
  );
};
